import { Platform } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors) => ({
  monthText: {
    marginBottom: theme.spacing[5],
    color: colors.textPrimary,
  },
  daysRow: {
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    width: '100%',
    columnGap: theme.spacing[4],
  },
  openCalendarButtonContainer: {
    flex: 1,
    alignItems: 'center',
    paddingTop: theme.spacing[Platform.OS === 'web' ? 2 : 1],
  },
  openCalendarButton: {
    alignItems: 'center',
    justifyContent: 'center',
    transform: [{ rotate: '270deg' }],
    borderRadius: theme.borderRadius.full,
    height: Platform.OS === 'web' ? 40 : 36,
    width: 'auto',
    aspectRatio: 1,
    padding: theme.spacing[3],
  },
  container: {
    flex: 1,
  },
  flatListContent: {
    paddingHorizontal: theme.spacing[3],
  },
  separator: {
    width: theme.spacing[3],
  },
}));
